var _rect, _rect2, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMachineOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1745_29708",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1745_29708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24121 6.24219L17.7416 18.7426",
    stroke: "#909090",
    strokeWidth: 0.9,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.0017C9.5 12.6368 8.98513 13.1517 8.35 13.1517C7.71487 13.1517 7.2 12.6368 7.2 12.0017C7.2 11.3666 7.71487 10.8517 8.35 10.8517C8.98513 10.8517 9.5 11.3666 9.5 12.0017Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9138 10.4187L18.238 10.1067L18.238 10.1067L17.9138 10.4187ZM19.2772 11.835L18.953 12.1471L18.953 12.1471L19.2772 11.835ZM19.2539 12.2729L18.9647 11.9282H18.9647L19.2539 12.2729ZM17.1119 14.0698L17.4011 14.4145H17.4011L17.1119 14.0698ZM16.7211 14.0653L17.0181 13.7272L17.0181 13.7272L16.7211 14.0653ZM16.0396 12.8678C15.8529 12.7038 15.5685 12.7222 15.4045 12.909C15.2405 13.0957 15.259 13.38 15.4457 13.544L16.0396 12.8678ZM11.9605 13.2059V12.7559H11.6492L11.5394 13.0472L11.9605 13.2059ZM12.8164 9.8768C12.5679 9.8768 12.3664 10.0783 12.3664 10.3268C12.3664 10.5753 12.5679 10.7768 12.8164 10.7768V9.8768ZM8.55188 15.0493C6.7813 15.0493 5.37857 13.6777 5.37857 12.0251H4.47857C4.47857 14.21 6.32027 15.9493 8.55188 15.9493V15.0493ZM17.5896 10.7308L18.953 12.1471L19.6014 11.523L18.238 10.1067L17.5896 10.7308ZM18.9647 11.9282L16.8227 13.725L17.4011 14.4145L19.5431 12.6177L18.9647 11.9282ZM17.0181 13.7272L16.0396 12.8678L15.4457 13.544L16.4242 14.4034L17.0181 13.7272ZM11.5394 13.0472C11.1027 14.2062 9.93675 15.0493 8.55188 15.0493V15.9493C10.3045 15.9493 11.8103 14.8806 12.3816 13.3646L11.5394 13.0472ZM12.1867 12.7559H11.9605V13.6559H12.1867V12.7559ZM5.37857 12.0251C5.37857 10.6732 6.31402 9.51218 7.62643 9.13145L7.37567 8.26709C5.71076 8.75008 4.47857 10.2403 4.47857 12.0251H5.37857ZM12.8164 10.7768H17.6977V9.8768H12.8164V10.7768ZM16.8227 13.725C16.8794 13.6774 16.9624 13.6783 17.0181 13.7272L16.4242 14.4034C16.7024 14.6478 17.1174 14.6525 17.4011 14.4145L16.8227 13.725ZM18.953 12.1471C18.8928 12.0845 18.8981 11.984 18.9647 11.9282L19.5431 12.6177C19.8759 12.3385 19.9027 11.8359 19.6014 11.523L18.953 12.1471ZM18.238 10.1067C18.0966 9.95979 17.9016 9.8768 17.6977 9.8768V10.7768C17.6569 10.7768 17.6179 10.7602 17.5896 10.7308L18.238 10.1067Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineOff);
export default __webpack_public_path__ + "static/media/machine_off.f4ba433e07c40abc7d72037044673ace.svg";
export { ForwardRef as ReactComponent };